module.exports = __webpack_public_path__ + "static/media/loans.e3b515bf.svg";